import {
  SETTING_RECEIPT_PAGE_REQUEST,
  SETTING_RECEIPT_SUBMIT_FORM,
  SETTING_RECEIPT_CHANGE_OUTLET,
  SETTING_RECEIPT_CHANGE_OUTLET_NAME,
  SETTING_RECEIPT_SET_PROFILE,
  SETTING_RECEIPT_CHANGE_PAGE,
  SETTING_RECEIPT_SET_OUTLETS
} from './constants'

/**
 * @param {int} outletId
 * @param {object} data
 * @param {object} query
 * @return {{type, payload: {outletId: *, data: *, query: *}}}
 */
export function submitForm (outletId, data, query) {
  return {type: SETTING_RECEIPT_SUBMIT_FORM, payload: {outletId, data, query}}
}

/**
 * @param {array} outletIds
 * @return {{type, payload: {outletIds: *}}}
 */
export function changeOutlet (outletIds) {
  return {type: SETTING_RECEIPT_CHANGE_OUTLET, payload: {outletIds}}
}

/**
 * @param {string} name new name of outlet
 * @param {array} outlets
 * @param {object} currentProfile profile get from /profile api
 */
export function changeOutletName (name, outlets, currentProfile) {
  return {type: SETTING_RECEIPT_CHANGE_OUTLET_NAME, payload: {name, outlets, currentProfile}}
}

/**
 * @return {{type, payload: {}}}
 */
export function pageRequest () {
  return {type: SETTING_RECEIPT_PAGE_REQUEST, payload: {}}
}

export function setProfile (profile) {
  return {type: SETTING_RECEIPT_SET_PROFILE, payload: {profile}}
}

export function changePage (nextLocation) {
  return {type: SETTING_RECEIPT_CHANGE_PAGE, payload: {nextLocation}}
}

export function setOutlets (outlets) {
  return {type: SETTING_RECEIPT_SET_OUTLETS, payload: {outlets}}
}



// WEBPACK FOOTER //
// ./app/actions/setting/receipt/index.js